import React from 'react'
import styled from 'styled-components'
import { Box } from '@pancakeswap/uikit'
import Container from '../Layout/Container'

const Outer = styled(Box)<{ background?: string }>`
  // background: ${({ theme, background }) => background || theme.colors.gradients.bubblegum};
  background: none;
  background-size: auto 100%;
  @media (min-width: 320px) and (max-width: 780px) {
    background-size: auto 75%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    background-size: auto 50%;
  }

`

const Inner = styled(Container)`
  padding-top: 0px;
  padding-bottom: 0px;

  @media (min-width: 320px) and (max-width: 480px) {
    padding-top: 0px;
    padding-bottom: 50px;
  }
`

const PageHeader: React.FC<{ background?: string }> = ({ background, children, ...props }) => (
  <Outer background={background} {...props}>
    <Inner>{children}</Inner>
  </Outer>
)

export default PageHeader
